import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { KPIData } from '../../../pages/dashboard/dashboard.model';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-dashboard-card',
  imports: [TooltipModule, Skeleton],
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardCardComponent {
  @Input() kpiData: KPIData = {
    title: '',
    count: '',
    details: '',
  };

  @Output() titleSelected = new EventEmitter<void>();

  onTitleClick(): void {
    this.titleSelected.emit();
  }
}
